import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikProps } from "formik";
import moment from "moment";
import { TransactionFilterDialogValues } from "src/models/Transactions.model";
import TransactionFilterDialog from "./TransactionFilterDialog";

type Props = {
  onClose: () => void;
  formValues: any;
  handleFilter: any;
};

const TransactionFilterDialogWrapper = ({
  onClose,
  formValues,
  handleFilter,
}: Props) => {
  const { dateFilter, transactionType, account, mode , dateFilterForPaymentDate } = formValues;
 
  // Form Initial Values
  const initialValues: TransactionFilterDialogValues = { 
    paymentStartDate: dateFilterForPaymentDate?.startDate || null ,
    paymentEndDate : dateFilterForPaymentDate?.endDate || null ,  
    startDate: dateFilter?.startDate || null,
    endDate: dateFilter?.endDate || null,
    transactionType: transactionType || [],
    account: account || [],
    mode: mode|| [],
  };

  // Handle Submit
  const handleSubmit = (values: TransactionFilterDialogValues) => {
    handleFilter({
      startDate:values?.startDate ? moment(values?.startDate).format("YYYY-MM-DD") :"",
      endDate:values?.endDate ? moment(values?.endDate).format("YYYY-MM-DD") : "",
      paymentStartDate : values?.paymentStartDate  ? moment(values?.paymentStartDate).format("YYYY-MM-DD") : "" ,
      paymentEndDate : values?.paymentEndDate ? moment(values?.paymentEndDate).format("YYYY-MM-DD") : "" ,
      transactionType: values?.transactionType,
      accountId: values?.account,
      mode: values?.mode,
    });
    onClose()
  };
  const handleReset = (
    formikProps: FormikProps<TransactionFilterDialogValues>
  ) => {
    handleFilter({
      startDate: "",
      endDate: "",
      paymentStartDate :'',
      paymentEndDate :'',
      transactionType: [],
      account: [],
      mode: [],
    });
    formikProps?.resetForm();
  };

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            <TransactionFilterDialog
              formikProps={formikProps}
              onClose={onClose}
              handleReset={() => handleReset(formikProps)}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default TransactionFilterDialogWrapper;
